/**
 * @file 
 *
 */
'use strict';

/**
 * @classname FormAppendOptionYearView
 * @classdesc 
 */
export default class FormAppendOptionYearView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('FormAppendOptionYearView.constructor');
		this._$e = $e;
		this.appendOption();
	};

	appendOption() {
		console.log('FormAppendOptionYearView.appendOption');
		const today = new Date();
		for(let i = today.getFullYear(); i > (today.getFullYear() - 100); i--) {
			this._$e.append(`<option value="${i}">${i}</option>`);
		}
	}
}
